<template>
  <div class="configure_property">
    <!-- <div class="configure_property__reload">
      <p class="configure_property__text--title_access" >
        Configurar Inmueble
      </p>
    </div> -->

    <div class="table_card">
      <div class="table_card__head" style="padding: 35px 25px">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Paquetería
            </p>
          </v-flex>
        </v-layout>
      </div>

      <v-layout>
        <v-flex class="configure_property__selector--initial_selector">
          <v-card-text class="configure_property__selector--card">
            <v-list two-line>
              <template v-for="(location, index_l) in locations">
                <v-list-tile
                  :key="index_l"
                  avatar
                  ripple
                  @click="toggleLocation(location.id)"
                  class="configure_property__selector--item"
                >
                  <v-list-tile-content>
                    <div
                      class="configure_property__selector--item_title"
                      :style="location.id == selected_location ? 'font-weight: 600; color: #2196f3' : ''">
                      {{ location.attributes.name }}
                  </div>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider
                  v-if="index_l + 1 < locations.length"
                  :key="'dl'+index_l"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-flex>

        <v-divider vertical></v-divider>

        <v-flex xs12 md6 class="configure_property__selector--initial_selector">
          <v-card-text class="configure_property__selector--card">
            <v-list two-line>
              <v-list-tile
                avatar
                ripple
                @click="toggleSelectedSublocations()"
                class="configure_property__selector--item"
                v-if="select_option">                    
              </v-list-tile>

              <template v-for="(sublocation, index_s) in sublocations">
                <v-list-tile
                  :key="index_s"
                  avatar
                  ripple
                  @click="toggleSublocation(sublocation.id)"
                  class="configure_property__selector--item">

                    <div
                      class="configure_property__selector--item_title"
                      :style="sublocation.id == selected_sublocation ? 'font-weight:600; color: #2196f3;' : '' "
                      v-if="!select_option">
                      {{ sublocation.name }}
                    </div>

                    <div
                      class="configure_property__selector--item_title"
                      :style="selected_sublocations.includes(sublocation.id) ? 'font-weight:600; color: #2196f3;' : ''"
                      v-else>

                      {{ sublocation.name }}

                      <v-checkbox
                        style="display: flex; justify-content: flex-end; margin-top:0;"
                        :input-value="selected_sublocations.includes(sublocation.id)"
                        color="#2196f3"
                        hide-details>
                      </v-checkbox>
                    </div>
                </v-list-tile>
                <v-divider
                  v-if="index_s + 1 < sublocations.length"
                  :key="'ds'+index_s"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-flex>

        <v-divider vertical></v-divider>

        <v-flex xs12 md6 :class="select_option ? 'configure_property__selector--main_selector center' : 'configure_property__selector--main_selector'">
          <v-card-text class="configure_property__selector--card" v-if="!disabled_selection">
            <div class="table_card__body" v-if="!disabled_selection" style="padding: 8px 16px 0 16px;">
              <div class="layout row wrap">
                <div class="configure_property__payments--user_section pr-3 xs12 lg6">
                  <label class="table_card__info--label custom_input__title--colapsed">
                    Usuario Asignado
                  </label>
                  <input type="text" disabled class="configure_property__payments--user" v-model="assigned_user"></div>
                </div>

                <!--<div class="flex" style="margin-top: 25px; max-width: 30%;">
                  <label class="table_card__info--label custom_input__title--colapsed">Año</label><br>
                  <date-picker
                      class="configure_property__payments--year_picker"
                      v-model="selected_year"
                      type="year"
                      @change="getParcels()"
                      required>
                  </date-picker>
                </div>-->
                <!--<div class="flex" style="margin-top: 25px; max-width: 30%;">
                  <v-btn
                    style="margin-bottom: 20px;"
                    color="primary"
                    @click="">
                    Cargar Foto
                  </v-btn>
                </div>-->

                <v-layout row wrap>
                  <div class="parcels__new_parcel--button_upload">
                    <label
                      for="parcel_photo"
                      class="faccess_button buttom_shadow px-5">Cargar Foto</label>
                    <input
                      id="parcel_photo"
                      type="file"
                      accept="image/x-png,image/gif,image/jpeg"
                      @change="onFileChange"
                      name="logo">
                  </div>
                  <div class="parcels__new_parcel--button_save">
                    <v-btn
                      class="faccess_button px-5"
                      style="margin: 0;"
                      :disabled="!uploaded_image"
                      @click="notificateParcel()">
                      Notificar
                    </v-btn>
                  </div>
                  <div class="parcels__new_parcel--image_container">
                    <a v-if="url" :href="getImageServer() + url" target="_blank">
                      <img
                        class="parcels__new_parcel--image_container__image"
                        :src="getImageServer() + url"
                        v-if="url"
                      >
                    </a>
                    <img
                      class="parcels__new_parcel--image_container__image"
                      src="@/assets/img/img-defecto.svg"
                      v-else
                    >
                  </div>
                </v-layout>
            </div>
            <v-list>
              <template v-for="(parcel, index_s) in parcels">
                <div :key="index_s" :id="index_s" class="parcels__parcel">                  
                    <div class="parcels__parcel--created">
                      <span>
                        {{ formatDate(parcel.attributes.created_at) }}
                      </span>
                    </div>

                  <div class="parcels__parcel--state">
                    <span>
                      {{ formatState(parcel.attributes.state) }}
                    </span>
                  </div>

                  <div class="parcels__parcel--btn">
                    <v-btn
                      class="v-btn theme--light info"
                      @click="showConfirmModal(parcel)"
                      v-if="parcel.attributes.state === 'CREATED'">Entregado
                    </v-btn>
                  </div>
                </div>

                <v-divider
                  v-if="index_s + 1 < parcels.length"
                  :key="'ds'+index_s">
                </v-divider>

              </template>
            </v-list>
          </v-card-text>

          <button
            class="faccess_button my-3"
            style="margin-right: 20px;"
            :disabled="!selected_sublocations.length > 0"
            v-else-if="select_option"
            @click="show_send_payments_modal = true">
            Crear pago ({{ selected_sublocations.length }})
          </button>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </div>

    <section
      v-if="show_confirm_modal"
      class="access_devices__modal">
      <section class="access_devices__modal--container">        
        <p class="access_devices__modal--text">
          ¿Desea confirmar que el paquete fue entregado al propietario del inmueble?
        </p>
        <div class="access_devices__modal--buttons">
          <div class="access_devices__modal--button" @click="show_confirm_modal = false">
            Cancelar
          </div>
          <div class="access_devices__modal--button active" @click="updateToDeliveredState()">
            Si
          </div>
        </div>
      </section>
    </section>

    <support-file-modal
      v-if="show_support_modal"
      :support_files="selected_support_files"
      :referenceDate="selected_support_date"
      @closeSupportModal="closeSupportModal()"
      @modifySupportState="modifySupportFileState($event)"
    >
    </support-file-modal>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        locations: [],
        sublocations: [],
        select_option: false,
        selected_sublocations: [],
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],        
        selected_location: '',
        selected_sublocation: '',
        disabled_selection: true,
        selected_year: new Date(),
        selected_month: '',
        selected_amount: '',
        selected_parcel_id: '',
        parcels: [],
        assigned_user: '',
        pages: 1,
        show_confirm_modal: false,
        show_send_payments_modal: false,
        show_support_modal: false,
        validAmount: true,
        selection_counter: 0,
        new_parcel: {},
        url: '',
        uploaded_image: false
      }
    },
    methods: {
      toggleSelection(){
        if(!this.select_option){
          this.select_option = true
          this.disabled_selection = true

        } else this.cleanUp()

      },
      toggleLocation(id){
        if(this.selected_location == id){
          this.selected_location = ''
          this.sublocations = []
          this.disabled_selection = true
        }else{
          this.selected_location = id
          this.selected_sublocation = ''
          this.disabled_selection = true
        }
        if(this.selected_location != null && this.selected_location != ''){
          this.getSublocations()
        }
      },
      toggleSublocation(id){
        if(this.select_option){
          if(this.selected_sublocations.includes(id)){
            this.selected_sublocations.splice(this.selected_sublocations.indexOf(id), 1)
            this.selection_counter -= 1
          } else {
            this.selected_sublocations.push(id)
            this.selection_counter += 1
          }
        }else if(this.selected_sublocation == id){
          this.selected_sublocation = ''
          this.disabled_selection = true
        }else{
          this.selected_sublocation = id
          this.disabled_selection = false
          this.getParcels()
        }
      },
      toggleSelectedSublocations(){
        if(this.selection_counter < this.sublocations.length){
          this.sublocations.forEach(subl => {
            if(!this.selected_sublocations.includes(subl.id)){
              this.selected_sublocations.push(subl.id)
              this.selection_counter += 1
            }
          })

        } else {
          this.sublocations.forEach(subl => {
            this.selected_sublocations.splice(this.selected_sublocations.indexOf(subl.id), 1)
          })
          this.selection_counter = 0
        }
      },
      updateSelectionCounter(){
        this.selection_counter = 0
        this.sublocations.forEach(subl => {
          if(this.selected_sublocations.includes(subl.id)) this.selection_counter += 1
        })
      },
      findLocations(){
        let params = { page: this.page }
        const data={company:{id:this.getCompany().id}}
        try {
          this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
            headers:
            {"X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
            params
          })
          .then(function(response){
            this.locations = response.body.data
            this.pages = response.body.meta.pages
            console.log("page <<<<<", this.page)
            console.log("pages <<<<<", this.pages)
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      },
      getSublocations(){
        try{
          this.$http.get('app/sublocations', {
            headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{ location_id: this.selected_location }
          }).then(function(response){
            this.sublocations=response.body;
            this.updateSelectionCounter()

            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if (response.status==401) {
              // alert(response.body.errors[0].details, "Un momento...");
              this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
              this.updateIsInAlert(true)
            }else{
              this.updateAlertMessage(response.body.errors[0].title);
              this.updateIsInAlert(true)
            }
          });
        }catch(e){
          alert(e.message);
        }
      },
      getParcels(){
        try{
          this.$http.get('parcels', {
            headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{ sublocation_id: this.selected_sublocation}
          }).then(function(response){
            this.assigned_user = response.body.meta.assigned_user;
            this.parcels = response.body.data;
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if (response.status==401) {
              // alert(response.body.errors[0].details, "Un momento...");
              this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
              this.updateIsInAlert(true)
            }else{
              this.updateAlertMessage(response.body.errors[0].details);
              this.updateIsInAlert(true)
            }
          });
        }catch(e){
          alert(e.message);
        }
      },
      updateToDeliveredState(){
        var data = { parcel_id: this.selected_parcel_id }
        try {
          this.$http.post('parcels/update_to_delivered_state',{ data: this.encrypt(data).toString()},
          {
            headers:{
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
          .then(function(response){
            this.show_confirm_modal = false
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)            
            this.getParcels()
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      },
      showConfirmModal(parcel){
        this.selected_parcel_id = parcel.id
        this.show_confirm_modal = true
      },
      cleanUp(){
        this.select_option = false
        this.selected_sublocation = ''
        this.selected_sublocations = []
        this.mass_payments_amount = ''
        this.selection_counter = 0
      },
      onFileChange (e) {
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        var name_field = ""+e.target.name
        this.url = URL.createObjectURL(files[0]);
        this.createImage(files[0], ""+e.target.name)
      },
      createImage (file, name_field) {
        var reader = new FileReader()
        var vm = this
        reader.readAsDataURL(file);
        reader.onload = function () {
          vm.new_parcel.file = reader.result
        }
        vm.uploaded_image = true
      },
      notificateParcel(){
        this.new_parcel.sublocation_id = this.selected_sublocation
        try {
          this.$http.post('parcels/create_parcel', {data: this.encrypt(this.new_parcel).toString()},
          {
            headers:{
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
          .then(function(response){
            this.updateAlertMessage(response.body.ans, "Hecho!");
            this.updateIsInAlert(true)
            this.new_parcel = {}
            this.url = '',
            this.uploaded_image = false
            this.getParcels()
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            console.log(response)
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if(typeof response.body.errors[0].details != "object"){
              this.updateAlertMessage(response.body.errors[0].details);
              this.updateIsInAlert(true)
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              this.updateAlertMessage(message);
              this.updateIsInAlert(true)
            }
          })
        } catch (e) {
          this.updateAlertMessage(e.message);
          this.updateIsInAlert(true)
        }
      },
      formatDate(value) {
        var date = new Date(value)
        console.log("DATE format!!!", date)
        var month="Mes"
        if(!isNaN(date.getMonth())){
          month=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"][date.getMonth()]
        }
        return date.getDate() + " de " + month + " de " + date.getFullYear()
      },
      formatState(state){
        if (state === "CREATED"){
          return "NOTIFICADO"
        }else if(state === "DELIVERED"){
          return "ENTREGADO"
        }else if(state === "RECEIVED"){
          return "RECIBIDO"
        }else if(state === "REJECTED"){
          return "RECHAZADO"
        }
      }
    },
    mounted(){
      this.findLocations()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/parcels/Index.vue